import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Auth.css";

function Login() {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      const res = await fetch("http://localhost:5000/api/users/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await res.json();

      if (res.ok) {
        setMessage("✅ " + data.message + " Welcome back, " + data.user.name + "!");
        setFormData({ email: "", password: "" });
      } else {
        setMessage("❌ " + data.message);
      }
    } catch (err) {
      console.error("Error:", err);
      setMessage("⚠️ Could not connect to the server.");
    }
  };

  return (
    <div className="auth-container">
      <h2>Login</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <input
          type="password"
          name="password"
          placeholder="Password"
          value={formData.password}
          onChange={handleChange}
          required
        />
        <button type="submit">Login</button>
      </form>

      {message && <p className="response-message">{message}</p>}

      <p>
        Don't have an account?{" "}
        <Link to="/signin" className="switch-link">
          Sign in here
        </Link>
      </p>
    </div>
  );
}

export default Login;

